export const addUserSelector = state => state.addUser;